/**
 * @generated SignedSource<<cbfda9b7e737fc6d015081a7c1c89f87>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ConfiguratorTemplateInput = {
  customToken?: string | null;
  modelID?: number | null;
  productID?: string | null;
  templateID?: number | null;
};
export type presetConfigurationsQueriesiFrameUrlQuery$variables = {
  input: ConfiguratorTemplateInput;
};
export type presetConfigurationsQueriesiFrameUrlQuery$data = {
  readonly preSetPreviewUrl: string | null;
};
export type presetConfigurationsQueriesiFrameUrlQuery = {
  response: presetConfigurationsQueriesiFrameUrlQuery$data;
  variables: presetConfigurationsQueriesiFrameUrlQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "preSetPreviewUrl",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "presetConfigurationsQueriesiFrameUrlQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "presetConfigurationsQueriesiFrameUrlQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "715595d4324e29f113866d467741fbff",
    "id": null,
    "metadata": {},
    "name": "presetConfigurationsQueriesiFrameUrlQuery",
    "operationKind": "query",
    "text": "query presetConfigurationsQueriesiFrameUrlQuery(\n  $input: ConfiguratorTemplateInput!\n) {\n  preSetPreviewUrl(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "6329516b2144aac69c60e433f07df685";

export default node;
